import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findCouponDetail = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-work/v1/coupon/details?` + params,
        method: 'GET'
    })
}

export const getBalance = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-wallet/v1/balance/getBalance?` + params,
        method: 'GET'
    })
}

export const immediatePay = (params) => {
    return request({
        url: `${baseUrl}/joins-work/v1/coupon/immediatePay`,
        method: 'PUT',
        data: params
    })
}
